export default {
  title: 'Wiki',
  description: 'En samling av brukergenerert dokumentasjon og veiledninger.',
  // Legg til flere oversettelser etter behov
};
